// JsFromRoutes CacheKey 6f5baeb927fcec93eaadb552148809a5
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  create: definePathHelper('post', '/admin/users/bulk_action'),
}
